import React from "react";
import { IconProps } from "../../components/Icon";

export default function DisconnectIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "80"}
      height={height || "80.241"}
      viewBox="0 0 80 80.241"
    >
      <g id="Illustration" transform="translate(-0.77 0)">
        <path
          id="Path_10383"
          data-name="Path 10383"
          d="M183.334,23.579l7.068,7.088a2.35,2.35,0,0,0,3.328,0l13.221-13.26a6.946,6.946,0,0,1,9.845,0,7.018,7.018,0,0,1,0,9.893l-13.221,13.26a2.35,2.35,0,0,0,0,3.318l7.068,7.088a2.35,2.35,0,0,0,3.328,0l13.858-13.9a21.782,21.782,0,0,0,0-30.706A21.489,21.489,0,0,0,212.51,0h0a21.491,21.491,0,0,0-15.318,6.363l-13.858,13.9a2.35,2.35,0,0,0,0,3.318Z"
          transform="translate(-153.389)"
          fill="#FEE0C0"
        />
        <path
          id="Path_10384"
          data-name="Path 10384"
          d="M51.116,213.624l-7.068-7.088a2.349,2.349,0,0,0-3.328,0L27.978,219.315a6.946,6.946,0,0,1-9.845,0,7.018,7.018,0,0,1,0-9.893l12.742-12.779a2.35,2.35,0,0,0,0-3.318l-7.068-7.088a2.349,2.349,0,0,0-3.328,0L7.1,199.654a21.782,21.782,0,0,0,0,30.706,21.62,21.62,0,0,0,30.636,0l13.379-13.418a2.35,2.35,0,0,0,0-3.318Z"
          transform="translate(0 -156.481)"
          fill="#FEE0C0"
        />
        <path
          id="Path_10375"
          data-name="Path 10375"
          d="M183.334,23.579l7.068,7.088a2.35,2.35,0,0,0,3.328,0l13.221-13.26a6.946,6.946,0,0,1,9.845,0,7.018,7.018,0,0,1,0,9.893l-13.221,13.26a2.35,2.35,0,0,0,0,3.318l7.068,7.088a2.35,2.35,0,0,0,3.328,0l13.858-13.9a21.782,21.782,0,0,0,0-30.706A21.489,21.489,0,0,0,212.51,0h0a21.491,21.491,0,0,0-15.318,6.363l-13.858,13.9a2.35,2.35,0,0,0,0,3.318Zm17.186-13.9a16.921,16.921,0,0,1,23.981,0,17.075,17.075,0,0,1,0,24.07l-12.195,12.23-3.75-3.761,11.567-11.6a11.726,11.726,0,0,0,0-16.529,11.645,11.645,0,0,0-16.5,0L192.066,25.681l-3.75-3.761Z"
          transform="translate(-153.389)"
          fill="#FB972E"
        />
        <path
          id="Path_10376"
          data-name="Path 10376"
          d="M51.116,213.624l-7.068-7.088a2.349,2.349,0,0,0-3.328,0L27.978,219.315a6.946,6.946,0,0,1-9.845,0,7.018,7.018,0,0,1,0-9.893l12.742-12.779a2.35,2.35,0,0,0,0-3.318l-7.068-7.088a2.349,2.349,0,0,0-3.328,0L7.1,199.654a21.782,21.782,0,0,0,0,30.706,21.62,21.62,0,0,0,30.636,0l13.379-13.418a2.35,2.35,0,0,0,0-3.318ZM34.409,227.042a16.92,16.92,0,0,1-23.981,0,17.074,17.074,0,0,1,0-24.07l11.715-11.749,3.75,3.761L14.805,206.1a11.725,11.725,0,0,0,0,16.529,11.645,11.645,0,0,0,16.5,0l11.078-11.111,3.75,3.761Z"
          transform="translate(0 -156.481)"
          fill="#FB972E"
        />
        <path
          id="Path_10377"
          data-name="Path 10377"
          d="M5.73,144.755l10.881,2.728a2.35,2.35,0,0,0,1.143-4.558L6.873,140.2a2.35,2.35,0,0,0-1.143,4.558Z"
          transform="translate(-2.718 -118.19)"
          fill="#FB972E"
        />
        <path
          id="Path_10378"
          data-name="Path 10378"
          d="M70.837,73.549a2.35,2.35,0,0,0,3.328-3.318l-8.433-8.457A2.35,2.35,0,0,0,62.4,65.092Z"
          transform="translate(-51.418 -51.514)"
          fill="#FB972E"
        />
        <path
          id="Path_10379"
          data-name="Path 10379"
          d="M143.173,16.99a2.35,2.35,0,0,0,4.56-1.137L145.013,4.94a2.35,2.35,0,0,0-4.56,1.137Z"
          transform="translate(-117.751 -2.684)"
          fill="#FB972E"
        />
        <path
          id="Path_10380"
          data-name="Path 10380"
          d="M422.873,327.6l-10.881-2.728a2.35,2.35,0,0,0-1.143,4.558l10.881,2.728A2.35,2.35,0,0,0,422.873,327.6Z"
          transform="translate(-344.345 -273.922)"
          fill="#FB972E"
        />
        <path
          id="Path_10381"
          data-name="Path 10381"
          d="M370.933,367.866a2.35,2.35,0,0,0-3.328,3.318l8.433,8.457a2.35,2.35,0,0,0,3.328-3.318Z"
          transform="translate(-308.812 -309.66)"
          fill="#FB972E"
        />
        <path
          id="Path_10382"
          data-name="Path 10382"
          d="M329.23,411.468a2.35,2.35,0,0,0-4.56,1.137l2.72,10.913a2.35,2.35,0,0,0,4.56-1.137Z"
          transform="translate(-273.112 -345.534)"
          fill="#FB972E"
        />
      </g>
    </svg>
  );
}
